export const WHATSAPP_NUMBER = "5511989559862";
export const WHATSAPP_DISPLAY = "+55 11 98955-9862";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  general:
    "Olá ED LABS! Vim pelo site da Bio e gostaria de saber mais sobre como vocês podem ajudar minha empresa a crescer.",
  trafego:
    "Olá ED LABS! Tenho interesse na gestão de Tráfego Pago para escalar minhas vendas/leads. Podemos conversar?",
  design:
    "Olá ED LABS! Preciso de soluções de Design / Identidade Visual para minha marca. Como podemos começar?",
  web: "Olá ED LABS! Gostaria de um orçamento para criação de site/landing page de alta conversão.",
  ia: "Olá ED LABS! Tenho interesse em implementar Inteligência Artificial e Automações no meu negócio.",
  apps: "Olá ED LABS! Preciso desenvolver um aplicativo (nativo ou PWA) para minha empresa. Vamos conversar!",
  portfolio:
    "Olá ED LABS! Vim pelo site e quero conhecer o portfólio de projetos. Podem me enviar?",
  demo_institucional:
    "Olá ED LABS! Vi o exemplo de Site Institucional Profissional no site e quero um para minha empresa.",
  demo_catalogo:
    "Olá ED LABS! Vi o exemplo de Catálogo Digital no site e quero algo assim para meus produtos/serviços.",
  demo_landing:
    "Olá ED LABS! Vi o exemplo de Landing Page de Alta Conversão no site e quero uma para minha campanha.",
};
